import React from "react";

interface RowsPerPageSelectorProps {
    rowsPerPage: number;
    setRowsPerPage: (value: number) => void;
}

const RowsPerPageSelector: React.FC<RowsPerPageSelectorProps> = ({
    rowsPerPage,
    setRowsPerPage,
}) => {
    return (
        <div className="flex items-center space-x-2 w-full sm:w-auto">
            <label className="text-theme-xs text-gray-700 dark:text-gray-300">Show</label>
            <select
                className="border border-gray-400 dark:border-gray-600 rounded bg-white dark:bg-gray-800 text-theme-sm text-gray-900 dark:text-white px-3 py-1 h-9 pr-7 w-full sm:w-auto shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800"
                onChange={(e) => setRowsPerPage(Number(e.target.value))}
                value={rowsPerPage}
            >
                {[10, 25, 50, 100, 200].map((num) => (
                    <option key={num} value={num}>
                        {num}
                    </option>
                ))}
            </select>
            <span className="text-theme-xs text-gray-700 dark:text-gray-300">entries</span>
        </div>
    );
};

export default RowsPerPageSelector;
